export const BASE_API_URL = 'https://orders.nfiptn.com/v2/';
export const DOW_ABBREV = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const SITE_URL = `${window.location.protocol}//${window.location.host}`;
export const STORE_TIMEZONE = 'America/Los_Angeles';
